import React from "react";
import {connect} from "react-redux";
import './Empty.css';
import {get} from '../../utils/api';
import {Link} from 'react-router-dom'
import {deleteEmptyCampaign} from "../../actions/campaignActions";
import {fetchSearchData} from "../../actions/searchActions";
import Loading from '../Shared/Loading';

class EmptyCampaigns extends React.Component {
        constructor(props) {
        super(props);
        this.state = {
            campaigns: [],
            loading: true,
        };
        this.getCampaigns = this.getCampaigns.bind(this);
        this.deleteCampaign = this.deleteCampaign.bind(this);
    }
    componentDidMount() {
        this.getCampaigns();
     };
     getCampaigns() {
        return get('manage/campaigns')
            .then((res) => {
                this.setState({
                    campaigns: res.result,
                    loading: false,
                })
            });
    }
    deleteCampaign(cid) {
        const res = window.confirm('Are you sure you want to delete the campaign?');
        if (res) {
            this.props.dispatch(deleteEmptyCampaign(cid)).then(() => {
                this.getCampaigns();
            });
            this.props.dispatch(fetchSearchData());
        }
    }

    render(){
        return(
            <div className="campaign-info">
                <h2># of Empty Campaigns: {this.state.campaigns.length}</h2>
                {this.state.loading ?  <Loading /> :
                <table className="table blank-table">
                    <thead>
                        <tr>
                            <th>Campaign Name</th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.state.campaigns.length !== 0 ? this.state.campaigns.map((campaign, k) => {
                        return(
                            <tr key={k}>
                                <td><Link key={k} to={`/campaign/${campaign.id}`}>{campaign.name}</Link></td>
                                <td>
                                    <button className="button button--red mr-10"
                                    onClick={() => this.deleteCampaign(campaign.id)}>Delete Campaign
                                    </button>
                                </td>
                            </tr>
                        )
                    }) : <tr><td style={{flexBasis: '100%'}}><h3>There are no empty campaigns.</h3></td></tr>}
                    </tbody>
                </table>
                }
            </div>
        )
    }
}
export default connect(null)(EmptyCampaigns);